var _a;
import { __decorate, __metadata } from "tslib";
import { DebounceAll } from 'lodash-decorators';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
let AppMarkdown = class AppMarkdown extends Mixins(Vue) {
    currentUserSelection = null;
    insertTableXValue = 1;
    insertTableYValue = 1;
    isFullScreen = false;
    isPreviewing = false;
    markdownDisplayValue = '';
    shouldShowSlashMenu = false;
    slashMenuPosition = { x: '0', y: '0' };
    TOOLBAR_ICON_SIZE = '16px';
    disabled;
    label;
    placeholder;
    required;
    removeDefaultMaxWidth;
    value;
    get hasCurrentUserSelection() {
        return (this.currentUserSelection && this.currentUserSelection.selectionStart !== this.currentUserSelection.selectionEnd);
    }
    // TODO: slash menu functionality is still a work in progress and is opt in.
    // Whether the slash menu is enabled, not necessarily whether it's showing right now.
    get isUsingSlashMenu() {
        return Boolean(this.$slots['slash-menu']);
    }
    applyFormat(type) {
        const textarea = this.$refs.textarea;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selected = (this.value || '').substring(start, end);
        let wrapper = '';
        switch (type) {
            case 'bold':
                wrapper = '**';
                break;
            case 'italic':
                wrapper = '_';
                break;
            case 'strikethrough':
                wrapper = '~~';
                break;
            default:
                wrapper = '';
        }
        const formatted = `${wrapper}${selected}${wrapper}`;
        this.emitInput((this.value || '').substring(0, start) + formatted + (this.value || '').substring(end));
        // Reselect the newly wrapped content
        this.$nextTick(() => {
            const offset = wrapper.length;
            textarea.setSelectionRange(start + offset, end + offset);
            textarea.focus();
        });
    }
    created() {
        this.markdownDisplayValue = this.value;
    }
    showSlashMenu() {
        const mirror = this.$refs.mirror;
        const textarea = this.$refs.textarea;
        if (!textarea || !mirror) {
            console.error('Markdown textarea or mirror element not found');
            return;
        }
        // Get caret position
        const pos = textarea.selectionStart;
        // keep line breaks visible
        const textBefore = textarea.value.slice(0, pos).replace(/\n$/, '\n\u200b');
        const textAfter = textarea.value.slice(pos);
        mirror.innerHTML = ''; // Clear the mirror before setting new content
        mirror.innerText = textBefore;
        // create and place a marker element
        const marker = document.createElement('span');
        marker.className = 'marker';
        mirror.appendChild(marker);
        // add the text after the marker
        mirror.appendChild(document.createTextNode(textAfter));
        const { left, top } = marker.getBoundingClientRect();
        this.slashMenuPosition = {
            x: `${left + window.scrollX}px`,
            // offset the top slightly to put the menu under the caret
            y: `${top + window.scrollY + 21}px`
        };
    }
    uiClickOfContinueEditing() {
        this.isPreviewing = false;
    }
    uiClickOfFullScreen() {
        this.isFullScreen = !this.isFullScreen;
    }
    uiClickOfInsertTable() {
        const stuffBeforeSelection = (this.value || '').substring(0, this.currentUserSelection?.selectionStart || 0);
        const stuffAfterSelection = (this.value || '').substring(this.currentUserSelection?.selectionStart || 0);
        const table = `|${' header |'.repeat(this.insertTableXValue)}
|${'------|'.repeat(this.insertTableXValue)}
|${' content |'.repeat(this.insertTableXValue)}
`;
        this.emitInput(`${stuffBeforeSelection}${table}${stuffAfterSelection}`);
    }
    uiClickOfPreview() {
        this.isPreviewing = true;
    }
    uiClickOfQuickAction() {
        console.log('implement me.');
    }
    emitInput(value) {
        return value;
    }
    onKeyDown(evt) {
        // if the slash menu is open, reposition it
        if (this.shouldShowSlashMenu) {
            this.showSlashMenu();
        }
        if (evt.key === 'Escape' && this.isFullScreen) {
            this.isFullScreen = false;
            return;
        }
        if (evt.key === '/' && this.isUsingSlashMenu) {
            // show quick action menu
            this.showSlashMenu();
            this.shouldShowSlashMenu = true;
        }
        const currentValue = evt.target.value;
        this.emitInput(currentValue);
    }
    onPreviewingChange(isPreviewing) {
        if (isPreviewing) {
            this.markdownDisplayValue = this.value;
        }
    }
};
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppMarkdown.prototype, "disabled", void 0);
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], AppMarkdown.prototype, "label", void 0);
__decorate([
    Prop({
        type: String,
        default: 'Type a comment'
    }),
    __metadata("design:type", String)
], AppMarkdown.prototype, "placeholder", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppMarkdown.prototype, "required", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppMarkdown.prototype, "removeDefaultMaxWidth", void 0);
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], AppMarkdown.prototype, "value", void 0);
__decorate([
    Emit('input'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AppMarkdown.prototype, "emitInput", null);
__decorate([
    DebounceAll(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], AppMarkdown.prototype, "onKeyDown", null);
__decorate([
    Watch('isPreviewing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppMarkdown.prototype, "onPreviewingChange", null);
AppMarkdown = __decorate([
    Component
], AppMarkdown);
export default AppMarkdown;
